<script>
import { DropdownMenu, DropdownItem } from 'vant'
import MemberIndexList from '@/fcl/components/user/MemberIndexList'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'
import Referee from '@/fcl/tbs/model/vo/Referee'
import ObjectFunc from '@/fcl/tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-referee-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-dropdown-menu': DropdownMenu,
        'van-dropdown-item': DropdownItem,
        'member-index-list': MemberIndexList,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            refereeList: null,
            organizationId: null,
            sportType: '0',
            status: '1',
            referee: new Referee,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        filteredRefereeList() {
            // console.log('filteredRefereeList', this.refereeList, this.sportType, this.status)
            let refereeList = ObjectFunc.cloneObject(this.refereeList)
            if (refereeList && refereeList.length > 0) {
                if (this.sportType) {
                    refereeList = refereeList.filter(referee => (referee.sportType == this.sportType || this.sportType == '0'))
                }
                if (this.status) {
                    refereeList = refereeList.filter(referee => referee.status == this.status)
                }
            }
            return refereeList
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onRefereeItemClick(item) {
            console.log('onRefereeItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgDetailReferee',
                    params: {
                        id: item.id
                    },
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onRefereeItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgCreateReferee',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onRefereeInvite(item) {
            console.log('onRefereeInvite', item)
            this.$emit('custom-event', {
                type: 'invite-referee',
                data: {
                    id: item.id,
                    organizationId: this.organizationId,
                    name: item.name,
                    roleLabel: item.roleLabel
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgCreateReferee',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
    },
}
</script>
<template>
    <div class="referee-list">
        <van-dropdown-menu class="van-hairline--bottom">
            <van-dropdown-item
                v-model="sportType"
                :options="referee.sportTypeOptions()"
            />
            <van-dropdown-item
                v-model="status"
                :options="referee.statusOptions()"
            />
        </van-dropdown-menu>
        <member-index-list
            :memberList="filteredRefereeList"
            :memberEmptyHint="locale['referee-empty-hint']"
            :memberInviteLabel="locale['invite-label']"
            @create-member="onRefereeItemCreate"
            @click-member="onRefereeItemClick"
            @invite-member="onRefereeInvite"
        />
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
    </div>
</template>